import React, { useContext, useEffect, useRef, useState } from 'react';
import { registerSenderRequest, verifySenderRequest, verifySenderStatusRequest, deleteBeneficiaryRequest, bioKycDmt, AddBeneficiaryVerifyOtp, deleteBeneficiaryConfirm } from '../../utils/api';
import OfferBanner from '../OfferBanner';
import { AlertWrapper, TableWrapper } from '../UI/styledConstants';
import { Wrapper } from './style';
import { clickOutside, getLocation, isEmpty, isValidMobileNumber, overLayers } from '../../utils/common';
import PayModal from './PayModal';
import AddBeneficiaryModal from './AddBeneficiary';
import OtpModal from './OtpModal';
import Conform from './Conform';
import Loader from '../UI/Loader/Loader';
import Receipt from './Receipt';
import IconClose from '../../assets/images/IconClose';
import Pagination from '../Pagination/Pagination';
import { GlobleContaxt } from '../../Context/GlobleContaxt';

import SelectDeviceType from '../AEPS/SelectDeviceType';
import CaptureFingerprint from '../AEPS/CaptureFingerprint';

import { parseString } from 'xml2js';
import Input from '../UIbox/Input';
import RadioButtonConfirm from '../UI/RadioButtonConfirm';
import user from "../../assets/images/circle-user_.svg";
import userWallet from "../../assets/images/wallet.svg";
import phoneIcon from "../../assets/images/phone-call.svg";
import { useAepsFingerprint } from './useAepsFingerprint';


// const selectType = [
// 	{ value: 'SEND_MONEY', label: 'Send Money' },
// 	{ value: 'PAST_TRANSACTIONS', label: 'Past Transactions' },
// 	{ value: 'ADD_NEW_PAYEE', label: 'Add New Payee' },
// ];

const initControls = {
	mobileNumber: '',
	encryptedAadhaar:"",
	referenceKey:""
	
};



export default function Sendmoney({ className = '' }) {
	const [senderMobile, setSenderMobile] = useState('');
	const [activeMobilePop, setActiveMobilePop] = useState(false);
	const [beneficiaryDetails, setBeneficiaryDetails] = useState(null);
	const [selectType, setSelectType] = useState('SEND_MONEY');
	const [controls, setControls] = useState({ ...initControls });
	const [modal, setModal] = useState({ name: '', modalData: null });
	const [loding, setLoding] = useState(false);
	const [lodingDelete, setLodingDelete] = useState(false);
	const [overlayer, setOverlayer] = useState(false);
	const [deleteUserData, setDeleteUserData] = useState({});
	const [message, setMessage] = useState({});
	const [otpMsg, setOtpMsg] = useState('');
	const [pgination, setPagination] = useState({ totalPage: 1, currentPage: 0, pageSize: 5 });
	const [filterText, setFilterText] = useState('');
	const [filterAccount, setFilterAccount] = useState('');
	const [filterType, setFilterType] = useState('name');
	const [filterData, setFilterData] = useState([]);
	const [referenceKey, setReferenceKey] = useState("");
	const [deviceType, setDeviceType] = useState('Mantra');
	const [fingerprintLoader_, setFingerprintLoader] = useState(false);
	const [otpRefKey,setOtpRefKey] = useState("");
   const [ wadh,setWadh] = useState("");




	const { setAlert,geolocation,setGeolocation } = useContext(GlobleContaxt);
	

	useEffect(() => {
		const dType = localStorage.getItem('deviceType');
		if (dType) {
			
			setDeviceType(dType);
		}
	}, []);

	const numberReg = /^[0-9]+$/;
	const nameReg = /^[A-Za-z\s]+$/i;
	const onChangeHandler = (e) => {
		

		const { name, value } = e.target;
		if ((name === 'mobileNumber') || name === 'encryptedAadhaar') {
			if (!numberReg.test(value) && value) {
				return false;
			}
		}

	
		const _controls = {
			...controls,
			[name]: value,
		};

		setControls(_controls);
	};

	const verifySenderStatus = async (mobileNumber) => {
		
		if(isEmpty(geolocation?.latitude)){
				setAlert({ type: 'warning', msg: 'Please allow access to your location', place: 'globle' });
				getLocation().then((position) =>{
					setGeolocation(position);
				})
	
				return;
			}
		
			
		if (!isEmpty(mobileNumber)) {
			if (!isValidMobileNumber(mobileNumber)) {
				setMessage({ type: 'error', msg: 'Please enter valid mobile', place: 'form' });
				return false;
			}
			setLoding(true);
			const response = await verifySenderStatusRequest(mobileNumber);

			if (response?.success) {

				if(response?.data?.mobileNumber){
					setBeneficiaryDetails(response?.data || []);
					setFilterData([]);
					setActiveMobilePop(true);
					setModal({ name: '', modalData: null })
					setSelectType("SEND_MONEY")
					setControls({...controls,mobileNumber:mobileNumber});
				}else{
					setBeneficiaryDetails(null);
					setFilterData([]);
					setWadh(response?.data?.pidOptionWadh);
					setSelectType('ADD_NEW_PAYEE');
					setControls({...controls,mobileNumber:mobileNumber});
					setAlert({ type: 'error', msg: response?.msg });
				}
				setReferenceKey(response?.data?.referenceKey);
				

				
			} else {
				setBeneficiaryDetails(null);
				setFilterData([]);

				if (response?.errorCodeList.length > 0) {
					setAlert({ type: 'error', msg: response?.errorCodeList[0] });
				} else {
					setAlert({ type: 'error', msg: response?.msg });
				}
			}

			setLoding(false);
		} else {
			setMessage({ type: 'error', msg: 'Please enter valid mobile number', place: 'form' });
			setLoding(false);
		}
	};

	const registerSender = async (resend = '') => {
		 if (isEmpty(controls?.mobileNumber)) {
			setMessage({ type: 'error', msg: 'Please enter mobile number', place: 'form' });
			return false;
		} else if(controls?.mobileNumber.length < 10){
			setMessage({ type: 'error', msg: 'Please enter valid mobile number  ', place: 'form' });
		}else if (isEmpty(controls?.encryptedAadhaar)) {
			setMessage({ type: 'error', msg: 'Please enter aadhar number', place: 'form' });
			return false;
		}else if(controls?.encryptedAadhaar.length < 12){
			setMessage({ type: 'error', msg: 'Please enter 12 digit  aadhar number', place: 'form' });
		}

		if (resend === 'resend') {
			setLodingDelete(true);
		} else {
			setLoding(true);
		}
		const response = await registerSenderRequest({ ...controls,referenceKey:referenceKey });
		setLoding(false);
		setLodingDelete(false);
		if (response?.success) {
			setOtpRefKey(response?.data?.referenceKey)
			setModal({ name: 'VERIFY_SENDER_OTP_MODAL', modalData: response });
		} else {
			if (response?.errorCodeList.length > 0) {
				if (response?.errorCodeList[0] == 'Success') {
					setMessage({ type: 'error', msg: 'This user already exist', place: 'globle' });
					setControls({ ...initControls });
				} else {
					setMessage({ type: 'error', msg: response?.errorCodeList[0], place: 'globle' });
				}
			} else {
				setMessage({ type: 'error', msg: response?.msg, place: 'globle' });
			}
		}
	};

	const onPayClick = (data) => {
		setModal({ name: 'PAY_MODAL', modalData: data });
	};
	const onAddBeneficiaryClick = (data = null) => {
		setModal({ name: 'ADD_BENEFICIARY_MODAL', modalData: data });
	};

	const onCloseModal = () => {
		setModal({ name: '', modalData: null });
		
	};

	const closeRecepit = () =>{
		onCloseModal();
		verifySenderStatus(controls?.mobileNumber);
	}

	const onSubmitOtp = (otp = '') => {
		setOtpMsg('');
		if (isEmpty(otp)) {
			setOtpMsg('Please enter otp');
			return;
		}
		if (modal?.name === 'VERIFY_SENDER_OTP_MODAL') {
			setLodingDelete(true);
		
			verifySenderRequest({
				mobileNumber:controls?.mobileNumber,
				otp: otp,
				referenceKey: otpRefKey,
			}).then((resp) => {
				setLodingDelete(false);
				if (resp?.success) {
					setModal({ name: '', modalData: null });
					//verifySenderStatus(controls?.mobileNumber);
					setAlert({ type: 'success', msg: resp?.msg });
					setReferenceKey(resp?.data.referenceKey);
					setOtpMsg('');

					setSenderMobile(controls?.mobileNumber);
					setSelectType('SELECT_EDVICE');
					setControls({ ...initControls });
				} else {
					if (resp?.errorCodeList.length > 0) {
						setOtpMsg(resp?.errorCodeList[0]);
					} else {
						setOtpMsg(resp?.msg);
					}
				}
			});
		}


		//deleteBeneficiaryConfirm
		if (!isEmpty(otp) && modal?.name === 'VERIFY_SENDER_OTP_DELETE') {
			setLodingDelete(true);
			deleteBeneficiaryConfirm({
				mobileNumber:controls?.mobileNumber,
				merchantId: '',
				beneficiaryId: deleteUserData?.id,
				otp: otp,
				referenceKey: modal?.modalData?.data?.referenceKey,
			}).then((resp) => {
				setLodingDelete(false);

				if (resp?.success) {
					setModal({ name: '', modalData: null });
					setOtpMsg('');
					verifySenderStatus(controls?.mobileNumber);
					setSenderMobile(controls?.mobileNumber);
					
					setControls({ ...initControls,mobileNumber:controls?.mobileNumber });
				} else {
					if (resp?.errorCodeList.length > 0) {
						setOtpMsg(resp?.errorCodeList[0]);
					} else {
						setOtpMsg(resp?.msg);
					}
				}
			});
		}

//verify sender 		
		if (!isEmpty(otp) && modal?.name === 'VERIFY_DDBENIFICILIA_OTP_MODAL') {
			setLodingDelete(true);
			setLoding(false);
			verifySenderRequest({
				merchantId: '',
				otp: otp,
				otpReference: modal?.modalData?.data?.otpReference,
			}).then((resp) => {
				setLodingDelete(false);
				if (resp?.success) {
					setModal({ name: '', modalData: null });
					verifySenderStatus(modal.mobileNumber);
		
					
					setControls({ ...initControls });
				} else {
					if (resp?.errorCodeList.length > 0) {
						setOtpMsg(resp?.errorCodeList[0]);
					} else {
						setOtpMsg(resp?.msg);
					}
				}
			});
		}

		// add BENEFICIARY_OTP
		if(!isEmpty(otp) && modal?.name === 'VERIFY_BENEFICIARY_OTP'){
			setLodingDelete(true);
			setLoding(false);
		
			 
			 AddBeneficiaryVerifyOtp({
				remitterMobileNumber:senderMobile,
				beneficiaryId: modal?.modalData?.data?.beneficiaryId,
				otp: otp,
				referenceKey: modal?.modalData?.data?.referenceKey,
			}).then((resp) => {
				setLodingDelete(false);
				if (resp?.success) {
					setModal({ name: '', modalData: null });
					verifySenderStatus(senderMobile);
		
					
					setControls({ ...initControls });
				} else {
					if (resp?.errorCodeList.length > 0) {
						setOtpMsg(resp?.errorCodeList[0]);
					} else {
						setOtpMsg(resp?.msg);
					}
				}
			});
		}
	};

	const ochangeMobileNumber = (e) => {
		if (isEmpty(localStorage.getItem('ID Token'))) {
			setAlert({ type: 'error', msg: 'Please login first to continue' });
			return;
		}

		if (!numberReg.test(e.target.value) && e.target.value) {
			return false;
		}
		setSenderMobile(e.target.value);
	};

	const deleteConfirm = (e, data) => {
		setOverlayer(true);
		setDeleteUserData(data);
	};

	const deleteHandeler = (resend = '') => {
		
		setLoding(true);
		setOverlayer(false);

		const param = {
			beneficiaryId: deleteUserData?.id,
			merchantId: '',
			mobileNumber: senderMobile,
		};

		deleteBeneficiaryRequest(param).then((response) => {
			setLoding(false);
			if (response.success) {
				setOverlayer(false);
				setAlert({ type: 'success', msg: response?.msg });
				setModal({ name: 'VERIFY_SENDER_OTP_DELETE', modalData: response });
			} else {
			
				if (response?.errorCodeList.length > 0) {
					setAlert({ type: 'error', msg: response?.errorCodeList[0] });
				} else {
					setAlert({ type: 'error', msg: response?.msg });
				}
			}
		});
	};

	useEffect(() => {
		if (!isEmpty(message)) {
			setTimeout(() => {
				setMessage({});
			}, 5000);
		}
	}, [message]);

	useEffect(() => {
		if (isEmpty(localStorage.getItem('ID Token'))) {
			setControls({ ...initControls });
			setSenderMobile('');
			setBeneficiaryDetails(null);
		}
	}, [localStorage.getItem('ID Token')]);

	const handleFilterChange = (e) => {
		const value = e.target.value.trim();
		const name = e.target.name;
		if (name === 'name') {
			if (!nameReg.test(value) && value) {
				return false;
			}

			setFilterType(name);
			setFilterText(value);
		}
		if (name === 'account') {
			if (!numberReg.test(value) && value) {
				return false;
			}
			setFilterAccount(value);
			setFilterType(name);
		}
	};

	useEffect(() => {
		if (!isEmpty(beneficiaryDetails?.beneficiaries)) {
			const filteredData = beneficiaryDetails?.beneficiaries.filter((item) => {
				if (filterType === 'name') {
					const pattern = new RegExp('^' + filterText, 'i');
					return pattern.test(item?.name);
				} else {
					const pattern = new RegExp('^' + filterAccount, 'i');
					return pattern.test(item?.account);
				}
			});

			setFilterData(filteredData);

			const totalPages = Math.ceil(filteredData.length / pgination.pageSize);

			setPagination({ ...pgination, currentPage: 0, totalPage: totalPages });
		}
	}, [filterText, filterAccount, beneficiaryDetails]);

	let testMantraPort = 1;
	
	function Capture() {
		setFingerprintLoader(true);
		var url = '';
		var PIDOPTS = '';
		let biometricData = null
		setLoding(true);
		if (deviceType === 'Morpho') {
			PIDOPTS = '<PidOptions ver="1.0">' + '<Opts fCount="1" fType="2" iCount="" iType="" pCount="" pType="" format="0" pidVer="2.0" timeout="10000" otp="" wadh="'+wadh+'" posh=""/>' + '</PidOptions>';
	
			if (testMantraPort === 1) {
				url = 'http://127.0.0.1:11100/capture';
			} else {
				url = 'https://127.0.0.1:11100/capture';
			}
		} else if (deviceType === 'Mantra') {
			PIDOPTS =
				'<PidOptions ver="1.0"> ' +
				'<Opts fCount="1" fType="2" iCount="0" pCount="0" pgCount="1" format="0"   pidVer="2.0" timeout="10000"  wadh="'+wadh+'" posh="" env="P" /> <CustOpts><Param name="mantrakey" value="" /></CustOpts>' +
				'</PidOptions>';
	
			const preUrl = localStorage.getItem('MantraRdUrl');
			if (preUrl) {
				url = preUrl;
			} else {
				if (testMantraPort === 1) {
					url = `https://127.0.0.1:11100/rd/capture`;
				} else if (testMantraPort === 2) {
					url = 'https://127.0.0.1:11101/rd/capture';
				} else if (testMantraPort === 3) {
					url = 'https://127.0.0.1:8005/rd/capture';
				}else if (testMantraPort === 4) {
					url = `http://127.0.0.1:11100/rd/capture`;
					} else if (testMantraPort === 5) {
							url = 'http://127.0.0.1:11101/rd/capture';
					}else if(testMantraPort === 6) {
						url = 'http://127.0.0.1:8005/rd/capture';
					}
			}
		} else if (deviceType === 'Tatvik') {
			url = 'https://127.0.0.1:11100/rd/capture';
		}
	
		var xhr;
	
		xhr = new XMLHttpRequest();
		xhr.open('CAPTURE', url, true);
		xhr.setRequestHeader('Content-Type', 'text/xml');
		xhr.setRequestHeader('Accept', 'text/xml');
	
		xhr.onreadystatechange = async function () {
			setFingerprintLoader(false);
			if (xhr.readyState === 4) {
				var status = xhr.status;
	
				if (status === 200) {
					var test1 = xhr.responseText;
					var test2 = test1.search('errCode');
					var test6 = getPosition(test1, '"', 2);
					var test4 = test2 + 9;

	
						convertXmlToJs(xhr.responseText).then((result) => {
	
						const error =	result?.PidData?.Resp[0].$;
						
						if(Number(error.errCode) != 0){
							setLoding(false);
							setAlert({ type: 'error', msg: error.errInfo });
							if (deviceType === 'Mantra') {
								localStorage.setItem('MantraRdUrl', url);
								// if (testMantraPort === 1) {
								// 	const url = `https://127.0.0.1:11100/rd/capture`;
								// 		localStorage.setItem('MantraRdUrl', url);
								// } else if (testMantraPort === 2) {
								// 	const url = 'https://127.0.0.1:11101/rd/capture';
								// 	localStorage.setItem('MantraRdUrl', url);
								// } else if (testMantraPort === 3) {
								// 	const url = 'https://127.0.0.1:8005/rd/capture';
								// 	localStorage.setItem('MantraRdUrl', url);
								// } 
							}
		
							return;
						}
							
						setLoding(false);
						setAlert({ type: 'success', msg: 'FingerPrint Captured Successfully' });
				
							 biometricData = {
								ci: result?.PidData?.Skey[0]?.$.ci,
								hmac: result?.PidData?.Hmac[0],
								pidData: result?.PidData?.Data[0]._,
								ts: result?.PidData?.DeviceInfo[0]?.additional_info[0]?.Param[2]?.$?.value,
								dc: result?.PidData?.DeviceInfo[0]?.$?.dc,
								mi: result?.PidData?.DeviceInfo[0]?.$?.mi,
								dpId: result?.PidData?.DeviceInfo[0]?.$?.dpId,
								mc: result?.PidData?.DeviceInfo[0]?.$?.mc,
								rdsId: result?.PidData?.DeviceInfo[0]?.$?.rdsId,
								rdsVer: result?.PidData?.DeviceInfo[0]?.$?.rdsVer,
								Skey: result?.PidData?.Skey[0]?._,
								srno: result?.PidData?.DeviceInfo[0]?.additional_info[0]?.Param[0]?.$?.value,
							};
						   
							verifyBioData(biometricData);
						  
							
						});
					  
					
				} else {
					setLoding(false);
				
				}
			}
		
		};
	
		xhr.onerror = function () {
			setFingerprintLoader(false);
			if (deviceType === 'Mantra') {
				setLoding(false);
				if (testMantraPort < 6) {
					testMantraPort = testMantraPort + 1;
					Capture();
				}
			}
			if (deviceType === 'Morpho') {
				setLoding(false);
				if (testMantraPort < 2) {
					testMantraPort = testMantraPort + 1;
					Capture();
				}
			}
		};
		xhr.send(PIDOPTS);
	}

	const verifyBioData = (biometric) =>{
		
		const param = {
			mobileNumber:senderMobile,
			referenceKey:referenceKey,
			latitude:geolocation?.latitude.toFixed(4),
			longitude:geolocation?.longitude.toFixed(4),

		 captureType:"FINGER",
			biometricData:biometric
		}
		

		console.log(JSON.stringify(param))

		setLoding(true);
		bioKycDmt(param).then(resp =>{
			setLoding(false);
			if(resp?.success){
	           verifySenderStatus(senderMobile);
	             setModal({ name: '', modalData: null })
			}else{
				setSelectType("SEND_MONEY")
				if (resp?.errorCodeList.length > 0) {
					setAlert({ type: 'error', msg: resp?.errorCodeList[0] });
				} else {
					setAlert({ type: 'error', msg: resp?.msg });
				}
			}
		});
	}
	



function convertXmlToJs(xmlData) {
	return new Promise((resolve, reject) => {
		parseString(xmlData, (err, result) => {
			if (err) {
				reject(err);
			} else {
				resolve(result);
			}
		});
	});
}

function getPosition(string, subString, index) {
	return string.split(subString, index).join(subString).length;
}

	const popupRef = useRef(null)
	useEffect(() =>{
		overLayers(activeMobilePop,"sm")
		clickOutside(activeMobilePop,popupRef,()=>{setActiveMobilePop(false)})
		return(()=>{
			overLayers(false,"sm")
		clickOutside(false,popupRef,()=>{setActiveMobilePop(false)})
		})
	},[activeMobilePop])

const goBack = () =>{
	setSelectType('SEND_MONEY');
	setOverlayer(false);
	setSenderMobile("");
	setControls({...initControls});
	setReferenceKey("");
	setBeneficiaryDetails(null)
	

}
const { captureFingerprint, loading:fingerprintLoader } = useAepsFingerprint();
const handleCapture = async () => {
    try {
      const data = await captureFingerprint(wadh);

      if(!data) return;

        convertXmlToJs(data).then((result) => {
    
                    
                
                        const	 biometricData = {
                                ci: result?.PidData?.Skey[0]?.$.ci,
                                hmac: result?.PidData?.Hmac[0],
                                pidData: result?.PidData?.Data[0]._,
                                ts: result?.PidData?.DeviceInfo[0]?.additional_info[0]?.Param[2]?.$?.value,
                                dc: result?.PidData?.DeviceInfo[0]?.$?.dc,
                                mi: result?.PidData?.DeviceInfo[0]?.$?.mi,
                                dpId: result?.PidData?.DeviceInfo[0]?.$?.dpId,
                                mc: result?.PidData?.DeviceInfo[0]?.$?.mc,
                                rdsId: result?.PidData?.DeviceInfo[0]?.$?.rdsId,
                                rdsVer: result?.PidData?.DeviceInfo[0]?.$?.rdsVer,
                                Skey: result?.PidData?.Skey[0]?._,
                                srno: result?.PidData?.DeviceInfo[0]?.additional_info[0]?.Param[0]?.$?.value,
                            };
                           
                            verifyBioData(biometricData);
                          
                            
                        });

      // Send to AEPS API
    } catch (err) {
     // console.error(err.message);
    }
  };

	return (
		<Wrapper className={`tab-content-wrapper ${className}`}>
			{(selectType !== "SELECT_EDVICE") && (selectType !== "CAPTURE_FINGER") &&<div className="tab-content-left">
				{<h2>Money Transfer </h2> }
				{/* <button className={`button-outline m`} onClick={handleCapture}>
					test button
				</button> */}
				<div className="form-field">
					{!isEmpty(message) && message.place === 'globle' && (
						<AlertWrapper className={`${message.type} globle`}>
							<span className="close" onClick={() => setMessage({})}>
								×
							</span>
							{message.msg}
						</AlertWrapper>
					)}
					
				</div>
				{selectType === 'SEND_MONEY' && (
					<>
						
						{isEmpty(beneficiaryDetails)?<Input  name="senderMobile" value={senderMobile} label="Sender Mobile" inputMode="numeric" maxLength="10" onChange={(e) => ochangeMobileNumber(e)} />
						: 
						<>
								<RadioButtonConfirm
							className="mb10 noHover"
							heading={(beneficiaryDetails?.firstName ?? "") + (beneficiaryDetails?.lastName ?? "")}
							label="Sender Name"
							name="addMoneyType"
							checked={false}
							error=""
							onClick={() =>{}}
							value=""
							img={user}
						/>
								<RadioButtonConfirm
							className="mb10 noHover"
							heading={senderMobile}
							label="Sender Mobile Number"
							name="addMoneyType"
							checked={false}
							error=""
							onClick={() =>{}}
							value=""
							img={phoneIcon}
						/>
								<RadioButtonConfirm
							className="mb10 noHover"
							heading={`₹${beneficiaryDetails?.limitTotal} / ₹${beneficiaryDetails?.limitAvailable}`}
							label="Available Limit"
							name="addMoneyType"
							checked={false}
							error=""
							onClick={() =>{}}
							value=""
							img={userWallet}
						/>
						</>
						
						}

						
						{!isEmpty(message) && message.place === 'form' && (
							<AlertWrapper className={message.type}>
								<span className="close" onClick={() => setMessage({})}>
									×
								</span>
								{message.msg}
							</AlertWrapper>
						)}

						 {isEmpty(beneficiaryDetails) && <button type="submit" className="button-outline mt20" onClick={() => verifySenderStatus(senderMobile)}>
							VERIFY SENDER
						</button>  }
						{!isEmpty(referenceKey) && <div style={{fontSize:"10px",cursor:"pointer",marginTop:"4px"}}>	<span onClick={goBack}><i class="fa-solid fa-angle-left"></i> Back</span></div>}
					
					</>
				)}
				{selectType === 'ADD_NEW_PAYEE' && (
					<>
					<Input type="text" name="mobileNumber" label="Mobile Number" inputMode="numeric" maxLength="10" value={controls?.mobileNumber} disabled={true} />
						
							
						<Input type="text" name="encryptedAadhaar" label="Aadhar number" value={controls?.encryptedAadhaar} maxLength="12" onChange={onChangeHandler} />
						
						
						
						{!isEmpty(message) && (
							<AlertWrapper className={message.type}>
								<span className="close" onClick={() => setMessage({})}>
									×
								</span>
								{message.msg}
							</AlertWrapper>
						)}
						<button type="submit" className="button-outline mt20" onClick={registerSender}>
							ADD NEW SENDER
						</button>
						{!isEmpty(referenceKey) && <div style={{fontSize:"10px",cursor:"pointer",marginTop:"4px"}}>	<span onClick={goBack}><i class="fa-solid fa-angle-left"></i> Back</span></div>}
					</>
				)}

			</div>}
			{ selectType == "SELECT_EDVICE" && (
				<SelectDeviceType setDeviceType={setDeviceType} deviceType={deviceType} setAepsStatus={setSelectType} aepsStatus={"sendMoney"} />
			)}

			 {selectType == "CAPTURE_FINGER" && (
				<CaptureFingerprint aepsStatus={"sendMoney"} fingerprintLoader={fingerprintLoader} Capture={handleCapture}  />
			)} 
			{!isEmpty(beneficiaryDetails) && (
				<div ref={popupRef}  className={`tab-content-right ${!activeMobilePop ? '' : 'active'}`}>
					<div
						className="d-m-block close-pop"
						onClick={() => {
							setActiveMobilePop(false);
						}}
					>
						<IconClose />
					</div>
					<div className="beneficiary-list-heading">
						<div>
							<h2>Beneficiary Details</h2>
							{beneficiaryDetails?.limitAvailable && (
								<div className="limit-available">
									Limit Available: <strong>{beneficiaryDetails?.limitAvailable}</strong>
								</div>
							)}
						</div>
						<div className="limit-with-action">
							{!isEmpty(beneficiaryDetails) && (
								<button type="submit" className="button-outline" onClick={onAddBeneficiaryClick}>
									ADD BENEFICIARY
								</button>
							)}
						</div>
					</div>
					<div className="filter flex gap-20">
						<div className="bold">Filter By</div>
						<input type="text" placeholder="Name" value={filterText} name="name" onChange={handleFilterChange} />
						<input type="text" placeholder="Account No" value={filterAccount} inputMode="numeric" name="account" onChange={handleFilterChange} />
					</div>
					{!isEmpty(beneficiaryDetails) && (
						<>
							<TableWrapper className="table-card-wrapper">
								<table className="table">
									<thead>
										<tr>
											<th>Sr No</th>
											<th>Beneficiary Name</th>
											<th>Account No.</th>
											<th>IFSC Code</th>
											<th>Beneficiary Mobile </th>
											<th>Bank</th>
											<th>Actions</th>
										</tr>
									</thead>
									<tbody>
										{filterData &&
											filterData.slice(pgination.currentPage * pgination.pageSize, pgination.currentPage * pgination.pageSize + pgination.pageSize).map((data, i) => (
												<tr key={i}>
													<td className="td-none">
														<span className="card-th">Sr No</span>
														<span>{pgination.currentPage * pgination.pageSize + i + 1}</span>
													</td>
													<td className="bold">
														<span className="card-th">Beneficiary Name</span>
														<span>{data?.name}</span>
													</td>
													<td>
														<span className="card-th">Account No.</span>
														<span>{data?.account}</span>
													</td>
													<td>
														<span className="card-th">IFSC Code</span>
														<span>{data?.ifsc}</span>
													</td>
													
													<td>
														<span className="card-th">Beneficiary Mobile</span>
														<span>{data?.beneficiaryMobileNumber}</span>
													</td>
													<td>
														<span className="card-th">Bank</span>
														<span>{data?.bank}</span>
													</td>
													<td style={{ display: 'flex', gap: '5px' }}>
														<button type="button" style={{ minWidth: '80px' }} className="button-outline" onClick={() => onPayClick(data)}>
															PAY
														</button>
														<button type="button" style={{ minWidth: '80px' }} className="button-outline" onClick={(e) => deleteConfirm(e, data)}>
															Delete
														</button>
													</td>
												</tr>
											))}
										{isEmpty(filterData) && (
											<tr>
												<td colSpan={6} style={{ textAlign: 'center', color: 'red' }}>
													No data found
												</td>
											</tr>
										)}
									</tbody>
								</table>
								{modal?.name === 'ADD_BENEFICIARY_MODAL' && (
				<AddBeneficiaryModal modalData={modal?.modalData} mobileNumber={senderMobile} onCloseModal={onCloseModal} verifySenderStatus={verifySenderStatus} setModal={setModal} />
			)}
						{modal?.name === 'TRANSACTION_SUCCESS_MODAL' && <Receipt onCloseModal={closeRecepit} modalData={modal?.modalData} />}
						{modal?.name === 'PAY_MODAL' && (
				<PayModal
					modalData={modal?.modalData}
					setModal={setModal}
					mobileNumber={controls?.mobileNumber}
					onCloseModal={onCloseModal}
					verifySenderStatus={verifySenderStatus}
					setLoding={setLoding}
					referenceKey={referenceKey}
				/>
			)}
						{overlayer && <Conform setOverlayer={setOverlayer} deleteUserData={deleteUserData} deleteHandeler={deleteHandeler} />}
				
			{modal?.name === 'VERIFY_SENDER_OTP_DELETE' && (
				<OtpModal
					modalData={modal?.modalData}
					onCloseModal={onCloseModal}
					onSubmitOtp={onSubmitOtp}
					setOtpMsg={setOtpMsg}
					otpMsg={otpMsg}
					lodingDelete={lodingDelete}
					resendOtp={deleteHandeler}
				/>
			)}
			{modal?.name === 'VERIFY_DDBENIFICILIA_OTP_MODAL' && (
				<OtpModal modalData={modal?.modalData} onCloseModal={onCloseModal} onSubmitOtp={onSubmitOtp} setOtpMsg={setOtpMsg} otpMsg={otpMsg} lodingDelete={lodingDelete} />
			)}
			{modal?.name === 'VERIFY_BENEFICIARY_OTP' && (
				<OtpModal
					modalData={modal?.modalData}
					onCloseModal={onCloseModal}
					onSubmitOtp={onSubmitOtp}
					setOtpMsg={setOtpMsg}
					otpMsg={otpMsg}
					lodingDelete={lodingDelete}
					resendOtp={()=>{}}
				/>
			)}
							</TableWrapper>
							{pgination?.totalPage > 1 && (
								<Pagination currentPage={pgination.currentPage} totalPages={pgination?.totalPage} getCurrentPageData={(page) => setPagination({ ...pgination, currentPage: page })} />
							)}

						</>
					)}
					{isEmpty(beneficiaryDetails) && <TableWrapper>Please verify sender to get beneficiaries.</TableWrapper>}
				</div>
			)}
			{isEmpty(beneficiaryDetails) && (
				<div className="tab-content-right">
					<OfferBanner />
				</div>
			)}


			
			
{modal?.name === 'VERIFY_SENDER_OTP_MODAL' && (
				<OtpModal
					modalData={modal?.modalData}
					onCloseModal={onCloseModal}
					onSubmitOtp={onSubmitOtp}
					setOtpMsg={setOtpMsg}
					otpMsg={otpMsg}
					lodingDelete={lodingDelete}
					resendOtp={registerSender}
				/>
			)}

			{loding && <Loader />}
		</Wrapper>
	);
}
